import { IAssetManagerStatusType } from '../../../../../generated/graphql.tsx';
import StatusChip from '../../../../technical/StatusChip.tsx';
import IconCheck from '@tabler/icons-react/dist/esm/icons/IconCheck';
import IconClockHour1Filled from '@tabler/icons-react/dist/esm/icons/IconClockHour1Filled';
import IconX from '@tabler/icons-react/dist/esm/icons/IconX';

export const RequestStatusChip = ({ status }: { status: IAssetManagerStatusType }) => {
  const size = 'md';
  switch (status) {
    case IAssetManagerStatusType.Completed:
      return (
        <StatusChip color="success" icon={IconCheck} size={size}>
          Completed
        </StatusChip>
      );
    case IAssetManagerStatusType.Failed:
      return (
        <StatusChip color="danger" icon={IconX} size={size}>
          Failed
        </StatusChip>
      );
    case IAssetManagerStatusType.Running:
      return (
        <StatusChip color="neutral" icon={IconClockHour1Filled} size={size}>
          Running
        </StatusChip>
      );
    default:
      return null;
  }
};
